import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import Webapp from '@/views/Webapp.vue'
import steps from './steps'
import { ACCOUNT_PERMISSION_ENUM } from '@/action-permissions/account.permissions'

Vue.use(Router)
const router = new Router({
  mode: 'history',
  base: process.env.VUE_APP_PUBLIC_PATH,
  routes: [
    {
      path: '/:merchant_id',
      name: 'merchant',
      component: Webapp,
      beforeEnter: (to, from, next) => {
        const { merchant_id: merchantId } = to.params

        if (!merchantId.includes('merch_')) {
          next({ name: 'default' })
          return
        }

        if (!store.getters.merchantSummary) {
          store.dispatch('GET_MERCHANT_SUMMARY', merchantId)
        }

        store.dispatch('GET_AUTHORIZATION', { merchantId }).then((res) => {
          if (!res.merchant) {
            next({ name: 'default' })
            return
          }

          next({ path: `${merchantId}/${res.merchant.account.id}/items` })
        })
      }
    },
    {
      path: '/:merchant_id/:account_id',
      component: Webapp,
      name: 'shop',
      beforeEnter: (to, from, next) => {
        const { merchant_id, account_id } = to.params

        if (!merchant_id.includes('merch_') || !account_id.includes('acc_')) {
          next({ name: 'default' })
          return
        }

        if (!store.getters.merchantSummary) {
          store.dispatch('GET_MERCHANT_SUMMARY', merchant_id)
        }

        if (!store.getters.profile) {
          store.dispatch('GET_AUTHORIZATION', { merchant_id, account_id }).then(() => {
            next()
          })
          return
        }

        next()
      },
      children: steps
    },
    {
      path: '/',
      name: 'default',
      component: Webapp,
      beforeEnter: (to, from, next) => {
        store.dispatch('GET_AUTHORIZATION', {}).then((res) => {
          if (!res.merchant) {
            next({ name: 'default' })
            return
          }

          if (!store.getters.permissionIsEnabled(ACCOUNT_PERMISSION_ENUM.ACCOUNT_GET)) {
            store.commit('toggleGlobalError', { status: true, code: 404 })
            return
          }

          store.dispatch('GET_MERCHANT_SUMMARY', res.merchant.id).then(() => {
            store.commit('toggleGlobalLoading', false)
            next({ path: `/${res.merchant.id}/${res.merchant.account.id}/` })
          })
        })
      }
    },
    {
      path: '*',
      redirect: { name: 'default' }
    }
  ]
})

export default router
